module.exports = __webpack_public_path__ + "img/6.6fc9322a.jpg";